export const menu = function (el) {
    if (!document.body.classList.contains("menu-enabled")) {
        document.body.classList.add("menu-enabled");
    } else {
        document.body.classList.remove("menu-enabled");
    }
};
